const uniq = <T>(array: Iterable<T>) => (array ? [...new Set<T>(array)] : array);

export default uniq;
